import React from "react";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import SearchBox from "components/SearchBox";

import axios from "axios";

import { API_URL, ERROR_HANDLE } from "config/constants";

class QRListScreen extends React.Component {
  style = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    filterIconWrapper: {
      margin: "0px 20px",
      backgroundColor: "#00b4d2",
      borderRadius: "100%",
      padding: "15px",
      cursor: "pointer"
    },
    filterIcon: {
      width: "30px",
      height: "30px"
    },
    box: {
      width: "1200px"
    }
  };

  state = {
    qlist: [],
    filteredQlist: []
  };

  QRListAPI = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/admin/qrcode_requests`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        this.setState({
          ...this.state,
          qlist: res.data,
          filteredQlist: res.data
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  QRListUpdateStatus = (id, status) => {
    const access_token = localStorage.getItem("access_token");
    axios
      .put(
        `${API_URL}/admin/qrcode_requests`,
        {
          id,
          status
        },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.QRListAPI();
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  componentDidMount() {
    this.QRListAPI();
  }

  searchHandler(e) {
    const filteredQlist = this.state.qlist.filter(gym => {
      const gymName = gym.gym_name;
      return gym.gym_name && gymName.toLowerCase().includes(e.target.value.toLowerCase()) > 0
    });
    this.setState({ ...this.state, filteredQlist });
  }

  render() {
    const { filteredQlist } = this.state;
    return (
      <div style={this.style.wrapper}>
        <SearchBox onChange={(e) => this.searchHandler(e)}>
          {/* DoNot Delete The Following */}
          {/* <div style={this.style.filterIconWrapper}>
                    <img
                    style={this.style.filterIcon}
                    src={require("assets/images/filter-white-nobg.png")}
                    alt="filter icon"
                    />
                </div> */}
        </SearchBox>
        <Box outline style={this.style.box}>
          {header()}
          {QRCodeRows(filteredQlist, this.QRListUpdateStatus)}
        </Box>
      </div>
    );
  }
}

export default QRListScreen;

const style = {
  titleWrapper: {
    display: "flex"
  },
  titleItem: {
    flex: "1",
    fontSize: "20px",
    color: "#00b4d2"
  },
  filtersWrapper: {
    display: "flex",
    justifyContent: "center"
  }
};

const headerlabels = ["Gym Name", "Name", "Email", "Approve/Decline"];
const headerItems = headerlabels.map((label, i) => (
  <p style={style.titleItem} key={i}>
    {label}
  </p>
));

const header = () => <div style={style.titleWrapper}>{headerItems}</div>;

const QRCodeRows = (qrcodes, QRListUpdateStatus) =>
  qrcodes.map((currentItem, i) => {
    const style = {
      itemWrapper: {
        display: "flex",
        width: "100%",
        alignItems: "center"
      },
      item: {
        flex: "1"
      },
      buttonsWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      approveButton: {
        height: "50px",
        width: "150px",
        fontSize: "18px",
        margin: "0px 10px"
      },
      declineButton: {
        height: "50px",
        width: "150px",
        fontSize: "18px",
        margin: "0px 10px",
        color: "#454545"
      }
    };
    return (
      <div key={i}>
        <hr style={{ borderTop: "1px solid #b5b5b6", borderRadius: "0.5px" }} />
        <div style={style.itemWrapper}>
          <p style={{ ...style.item }}>{String(currentItem.gym_name)}</p>
          <p style={{ ...style.item }}>{String(currentItem.name)}</p>
          <p style={{ ...style.item }}>{String(currentItem.email)}</p>
          {currentItem.status === "Pending" ? (
            <div style={{ ...style.item, ...style.buttonsWrapper }}>
              <Button
                type="primary"
                style={style.approveButton}
                onClick={() => {
                  QRListUpdateStatus(currentItem.id, 1);
                }}
              >
                Approve
              </Button>{" "}
              <Button
                style={style.declineButton}
                type="holo"
                holo
                onClick={() => {
                  QRListUpdateStatus(currentItem.id, -1);
                }}
              >
                Decline
              </Button>
            </div>
          ) : (
              <p
                style={{
                  ...style.item,
                  fontWeight: "300",
                  letterSpacing: "2px",
                  fontSize: "20px"
                }}
              >
                {String(currentItem.status)}
              </p>
            )}
        </div>
      </div>
    );
  });
